import { render, staticRenderFns } from "./BaseCardBtn.vue?vue&type=template&id=45530579&"
import script from "./BaseCardBtn.vue?vue&type=script&lang=ts&"
export * from "./BaseCardBtn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports